// ReingresoSerie.actions.ts
import { queryClient } from '@/shared/query-client/query-client';
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { UseFetchEnabledParams, UseMutationsParams, UseUpdateParams } from "@/shared/interfaces";
import { urlBackend } from "@/shared/constants";
import { erpApi } from "@/shared/axios";
import { getUrlParamsFetch } from "@/shared/utils";
import { toApiError } from "@/shared/utils/general";
import { ReingresoSerie, ReingresoSerieForm, ReingresoSerieMarcarReingresoForm, ReingresoSeriePagingResp, ReingresoSerieParams } from '@/erp/contabilidad/reingreso-serie';

const { get, post, put } = erpApi();

//const urlBackend = 'http://localhost:8093/'; // TODO: solo para pruebas

// get

export const useFetchGetReingresoSerie = ({
  enabled = true,
  params,
}: UseFetchEnabledParams<ReingresoSerieParams> = {}) => {
  return useQuery({
    queryKey: ['reingreso-serie', ...Object.values(params ?? {})],
    queryFn: () => getReingresoSerie(params),
    enabled: enabled,
    refetchOnWindowFocus: false,
  });
};

export const getReingresoSerie = async (
  params?: ReingresoSerieParams
) => {
  const queryParams = getUrlParamsFetch(params ?? {});
  return get<ReingresoSeriePagingResp>(`${urlBackend}api/v1/contabilidad/solicitud-reingreso-serie?${queryParams}`, true);
};

// create

export const useFetchPostReingresoSerie = ({
  returnUrl,
  navigate
}: UseMutationsParams = {}) => {

  return useMutation({
    mutationFn: (data: ReingresoSerieForm) => {
      return postReingresoSerie(data)
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: ['solicitud-reingreso-serie']
      });

      navigate && returnUrl && navigate(returnUrl);

      toast.success(data.message);

    },
    onError: ((error) => {
      const data = toApiError(error)
      toast.error(data.message)
    }),
    onSettled: () => {

    },
  });
};

export const postReingresoSerie = async (data: ReingresoSerieForm) => {
  return await post<ReingresoSerie>(`${urlBackend}api/v1/contabilidad/solicitud-reingreso-serie/bulk`, data, true);
};

// filter by id

export const useFetchGetByIdReingresoSerie = (id: string) => {
  return useQuery({
    queryKey: ['solicitud-reingreso-serie', id],
    queryFn: async () => {
      return getByIdReingresoSerie(id);
    },
    refetchOnWindowFocus: false,
  });
};

export const getByIdReingresoSerie = async (id: string) => {
  const res = await get<ReingresoSerie>(`${urlBackend}api/v1/contabilidad/solicitud-reingreso-serie/${id}`, true);
  return res;
};

// update

export const useFetchPutReingresoSerie = ({
  navigate,
  returnUrl
}: UseMutationsParams = {}) => {

  return useMutation({
    mutationFn: (data: UseUpdateParams<ReingresoSerieForm>) => {
      return putReingresoSerie(data);
    },
    onSuccess: (res) => {
      queryClient.invalidateQueries({
        queryKey: ['solicitud-reingreso-serie']
      });
      
      navigate && returnUrl && navigate(returnUrl);

      toast.success(res.message);
    },
    onError: (error) => {
      const data = toApiError(error)
      toast.error(data.message)
    },
    onSettled: () => {

    },
  });
};

export const putReingresoSerie = async ({
  id,
  data
}: UseUpdateParams<ReingresoSerieForm>) => {
  return put<ReingresoSerie>(`${urlBackend}api/v1/contabilidad/solicitud-reingreso-serie/${id}`, data, true);
};


// cambiar nombre de la serie con _REINGRESO
export const useFetchPostMarcarReingreso = ({
  returnUrl,
  navigate
}: UseMutationsParams = {}) => {

  return useMutation({
    mutationFn: (data: ReingresoSerieMarcarReingresoForm) => {
      return postMarcarReingreso(data)
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: ['solicitud-reingreso-serie']
      });

      navigate && returnUrl && navigate(returnUrl);

      toast.success(data.message);

    },
    onError: ((error) => {
      const data = toApiError(error)
      toast.error(data.message)
    }),
    onSettled: () => {

    },
  });
};

export const postMarcarReingreso = async (data: ReingresoSerieMarcarReingresoForm) => {
  return await post<ReingresoSerie>(`${urlBackend}api/v1/ingreso-inventario/marcar-reingreso/`, data, true);
};